import { ChangeDetectorRef, Component, Input, TemplateRef } from '@angular/core';
import { InputDisplay } from '../input-group/input-group.properties';
import { SelectFieldComponent } from '../select-field/select-field.component';

@Component({
  selector: 'shared-ui-inputs-select-group',
  templateUrl: './select-group.component.html',
  styleUrls: ['./select-group.component.css'],
  standalone: false,
})
export class SelectGroupComponent extends SelectFieldComponent {
  @Input() display = InputDisplay.Block;
  @Input() labelTooltipTemplate: TemplateRef<unknown> | null = null;
  @Input() labelColumns = 2;

  constructor(cdr: ChangeDetectorRef) {
    super(cdr);
  }

  isInline(): boolean {
    return this.display === InputDisplay.Inline || this.isJustified();
  }

  isInlineOnly(): boolean {
    return this.display === InputDisplay.Inline;
  }

  isJustified(): boolean {
    return this.display === InputDisplay.InlineSpaced;
  }
}
